import bgImg from '../../../../assets/market/marketplace_bg.jpeg'
import bgImg2 from '../../../../assets/market/marketplace_bg_2.png'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import './index.scss'
import { ReactComponent as Play } from "../../../../assets/Rectangle 6.svg";
import GlobalState, { watchVideo } from '../../../../stores/GlobalState'

const MarketplaceScreen = observer(() => {
  const marketplaceScreenContent: any = ContentState.home?.marketplace
  if (!ContentState.home?.marketplace) return <></>

  return (
    <section
      className={classNames("screen section you market nova")}
      id="market"
    >
      <div className={classNames("screen__container")}>
        <div className="screen__row">
          <div
            className="screen__title"
            dangerouslySetInnerHTML={{
              __html: marketplaceScreenContent.title,
            }}
          ></div>
          <div
            className="screen__text"
            dangerouslySetInnerHTML={{
              __html: marketplaceScreenContent.text,
            }}
          ></div>
        </div>
        {!GlobalState.video.show && (
          <div className={classNames("screen__video mob")}>
            <div
              className="screen__video-text"
              dangerouslySetInnerHTML={{
                __html: ContentState.home.thirdscreen.watchText,
              }}
            ></div>
            <div
              className={classNames("screen__video-play")}
              onClick={() =>
                watchVideo(
                  marketplaceScreenContent.src,
                  marketplaceScreenContent.poster
                )
              }
            >
              <Play />
            </div>
            <video
              id="#myVideo"
              poster={marketplaceScreenContent.poster}
              src={marketplaceScreenContent.src}
              autoPlay={false}
              preload={"preload"}
              controls={false}
            >
              <source src={marketplaceScreenContent.src}></source>
            </video>
          </div>
        )}
        <div className="screen__bottom">
          <div className="screen__bottom-btns">
            <a
              href={ContentState.subMenu?.forbusinessLink}
              className="button  black mr29"
            >
              <span> {ContentState.home.buttonYou.title}</span>
            </a>
            <a className="button white" href={ContentState.subMenu?.foryouLink}>
              <span>{ContentState.home.buttonBusiness.title}</span>
            </a>
          </div>
        </div>
      </div>
      <div
        className="screen__bg"
        style={{ backgroundImage: `url(${bgImg})` }}
      ></div>
      <div className="screen__bg-sm-wrp">
        <div
          className="screen__bg-sm"
          style={{ backgroundImage: `url(${bgImg2})` }}
        ></div>
      </div>
    </section>
  );
})

export default MarketplaceScreen
